import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DocumentationService {
  documentations = [
    {
      id: 'vendedores',
      slug: '/vendedores',
      title: 'Vendedores',
      filePath: '/documentation/vendedores/vendedores.md',
      chapters: [
        {
          id: 'kit-integracao',
          slug: '/vendedores/kit-integracao',
          title: 'Kit de Integração',
          filePath: '/documentation/vendedores/kit-integracao.md',
          children: [],
        },
        {
          id: 'autenticacao',
          slug: '/vendedores/autenticacao',
          title: 'Autenticação',
          filePath: '/documentation/vendedores/autenticacao.md',
          children: [],
        },
        {
          id: 'preco-e-estoque',
          slug: '/vendedores/preco-e-estoque',
          title: 'Preço & Estoque',
          filePath: '/documentation/vendedores/preco-estoque.md',
          children: [
            {
              id: 'ftp',
              slug: '/vendedores/preco-e-estoque/ftp',
              title: 'FTP',
              filePath: '/documentation/vendedores/preco-estoque-ftp.md',
            },
            {
              id: 'rest',
              slug: '/vendedores/preco-e-estoque/rest',
              title: 'REST API',
              filePath: '/documentation/vendedores/preco-estoque-rest.md',
            },
            {
              id: 'portal-do-vendedor',
              slug: '/vendedores/preco-e-estoque/portal-do-vendedor',
              title: 'Portal do Vendedor',
              filePath: '/documentation/vendedores/preco-estoque-portal-do-seller.md',
            },
          ],
        },
        {
          id: 'pedidos',
          slug: '/vendedores/pedidos',
          title: 'Pedidos',
          filePath: '/documentation/vendedores/pedidos.md',
          children: [
            {
              id: 'filiais',
              slug: '/vendedores/pedidos/filiais',
              title: 'Filiais',
              filePath: '/documentation/vendedores/pedidos-branches.md',
            },
            {
              id: 'webhook',
              slug: '/vendedores/pedidos/webhook',
              title: 'Notificação de Pedido',
              filePath: '/documentation/vendedores/pedidos-webhook.md',
            },
            {
              id: 'detalhes-do-pedido',
              slug: '/vendedores/pedidos/detalhes-do-pedido',
              title: 'Detalhes do Pedido',
              filePath: '/documentation/vendedores/pedidos-detalhes-do-pedido.md',
            },
            {
              id: 'responder',
              slug: '/vendedores/pedidos/responder',
              title: 'Responder Pedido',
              filePath: '/documentation/vendedores/pedidos-responder.md',
            },
          ],
        },
      ],
    },
  ];

  getChildContent(docSlug: string, chapterSlug: string, childSlug: string): string | null {
    const doc = this.documentations.find((d) => d.id === docSlug);
    const chapter = doc?.chapters.find((c) => c.id === chapterSlug);
    const child = chapter?.children.find((ch) => ch.id === childSlug);
    return child?.filePath || null;
  }

  getChapterContent(docSlug: string, chapterSlug: string): string | null {
    const doc = this.documentations.find((d) => d.id === docSlug);
    const chapter = doc?.chapters.find((c) => c.id === chapterSlug);
    return chapter?.filePath || null;
  }

  getDocContent(docSlug: string): string | null {
    const doc = this.documentations.find((d) => d.id === docSlug);
    return doc?.filePath || null;
  }
}
